import React from 'react'
import { Badge } from '@shared/components/ui/badge'
import { cn } from '@shared/lib/utils'

interface SubscriptionStatusBadgeProps {
  status: string
  className?: string
}

export const SubscriptionStatusBadge: React.FC<SubscriptionStatusBadgeProps> = ({ 
  status, 
  className 
}) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'active':
        return {
          variant: 'default' as const,
          className: 'bg-green-100 text-green-800 border-green-200',
          icon: '✅'
        }
      case 'canceled':
        return {
          variant: 'destructive' as const,
          className: 'bg-red-100 text-red-800 border-red-200',
          icon: '❌'
        }
      case 'cancel_at_period_end':
        return {
          variant: 'secondary' as const,
          className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
          icon: '⏰'
        }
      case 'past_due':
        return {
          variant: 'destructive' as const,
          className: 'bg-orange-100 text-orange-800 border-orange-200',
          icon: '⚠️'
        }
      case 'unpaid':
        return {
          variant: 'destructive' as const,
          className: 'bg-red-100 text-red-800 border-red-200',
          icon: '💳'
        }
      case 'trialing':
        return {
          variant: 'secondary' as const,
          className: 'bg-blue-100 text-blue-800 border-blue-200',
          icon: '🆓'
        }
      default:
        return {
          variant: 'secondary' as const,
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          icon: '❓'
        }
    }
  }

  const config = getStatusConfig(status)
  const displayStatus = status === 'cancel_at_period_end' ? 'Canceling' : 
                       status === 'past_due' ? 'Past Due' :
                       status === 'unpaid' ? 'Unpaid' :
                       status.charAt(0).toUpperCase() + status.slice(1)

  return (
    <Badge 
      variant={config.variant}
      className={cn(
        'flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium',
        config.className,
        className
      )}
    >
      <span>{config.icon}</span>
      {displayStatus}
    </Badge>
  )
}

